module.exports = __webpack_public_path__ + "img/bubble-ok.0863aa05.svg";